"use client";

import { useState } from "react";
import { CarouselPost } from "@kit/react-carousel";
import PostImage from "./components/PostImage";
import PostHeader from "./components/PostHeader";
import PostActions from "./components/PostActions";
import PostDescription from "./components/PostDescription";

type InstagramPost = {
    images: string[];
    imageUrl: string;
    avatarUrl: string;
    username: string;
    location: string;
    likes: number;
    description: string;
};

export default function InstagramPost({ post }: { post: InstagramPost }) {
    const [postData, setPostData] = useState(post);

    const handleDataChange = (key: string, value: string | number) => {
        setPostData((prev) => ({ ...prev, [key]: value }));
    };

    return (
        <div className="w-full max-w-md mx-auto bg-white border border-gray-200 rounded-md overflow-hidden">
            <PostHeader
                username={postData.username}
                location={postData.location}
                onDataChange={handleDataChange}
            />
            {postData.images && postData.images.length > 1 ? (
                <CarouselPost images={postData.images} type="instagram" onImagesChange={() => console.log("changed")} />
            ) : (
                <PostImage
                    imageUrl={postData.imageUrl}
                    onImageChange={(newUrl) => handleDataChange("imageUrl", newUrl)}
                />
            )}
            <PostActions likes={postData.likes} onDataChange={handleDataChange} />
            <PostDescription
                username={postData.username}
                description={postData.description}
                onDataChange={handleDataChange}
            />
        </div>
    );
}
